import React, { useEffect, useRef, useState } from 'react'

import { useHistory } from 'react-router-dom'

import { FontAwesomeIcon as FontA } from '@fortawesome/react-fontawesome'

import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'

import Icon, { EyeOutlined } from '@ant-design/icons'
import {
  Button,
  Card,
  Form,
  Input,
  message,
  Modal,
  Popconfirm,
  RefSelectProps,
  Select,
  Space,
  Switch,
  Table,
} from 'antd'

import { GoogleMap, InfoBox, Polygon } from '@react-google-maps/api'
import LinhaPlanejada from '../../../Components/linhaPlanejada'

import { Notification } from '../../../Components/notification'

import { useLogic } from '../../../context/useLogic'

import {
  delTalhaoCultivavel,
  getKmlTalhaoCultivavel,
  getTalhaoCultivavel,
  postObservacaoTalhao,
  TalhaoCultivaveisItens,
} from '../../../services/TalhaoSafra'

import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { pagination } from '../../../Components/Default'
import DesenhaTalhao from '../../../Components/desenhoTalhao'
import Icons from '../../../Components/Icons'
import { IconAlert } from '../../../Components/iconsAlert'
import ImporteKmlTalhao from '../../../Components/importKmlTalhao'
import FormTalhaoSafra from '../../../Components/talhaoSafra'
import Svg from '../../../Components/talhasvg'
import ViewPage from '../../../Components/ViewPage'
import { centerMap, getBounds, tryError } from '../../../services/Afins'
import { ItensPerUserLogged } from '../../../services/login/permissaoUsuarioLoado'
import { getPropriedade } from '../../../services/Propriedades'
import { getTalhao } from '../../../services/Talhao'
import { Container, ContainerMap } from './styled'

const { Option } = Select

interface TypesMapa {
  zoom: number
  center: {
    lat: number
    lng: number
  }
  style?: { [key: string]: string }
}

const TalhaoSafra: React.FC = () => {
  const history = useHistory()
  const { checkSafra, safraSelecionada } = useLogic()

  const [form] = Form.useForm()

  const refSelect = useRef<RefSelectProps>()
  refSelect.current
  const [dataTalhao, setDataTalhao] = useState([])
  const [observacao, setObservacao] = useState('')
  const [checkedTodos, setCheckedTodos] = useState(false)
  const [dataPropriedade, setDataPropriedade] = useState([])
  const [delListTalhao, setDelListTalhao] = useState([])
  const [codTalhaoSelec, setCodTalhaoSelec] = useState([])
  const [todosTalhoesSafra, setTodosTalhoesSafra] = useState([])
  const [talhoesCultivaveis, setTalhoesCultivaveis] = useState<TalhaoCultivaveisItens[]>([])
  const [polygonTalhao, setPolygonTalhao] = useState([])
  const [polygon, setPolygon] = useState<google.maps.Polygon>()
  const [map, setMap] = useState<google.maps.Map>()

  const talhaoSelecionado: TalhaoCultivaveisItens = {} as TalhaoCultivaveisItens
  const [loadingTable, setLoadingTable] = useState(false)
  const [visibleForm, setVisibleForm] = useState(false)
  const [modalTalhao, setModalTalhao] = useState(false)
  const [infoBoxNameTalhao, setInfoBoxNameTalhao] = useState(true)
  const [selectTalhoes, setSelectTalhoes] = useState(false)
  const [infoBoxAreaTalhao, setInfoBoxAreaTalhao] = useState(true)

  const infoWindow = new window.google.maps.InfoWindow()
  const [openMapLine, setOpenMapLine] = useState(false)
  const [visualizarPropriedade, setVisualizarPropriedade] = useState(false)
  const [openModalObservacao, setOpenModalObservacao] = useState(false)
  const [udateTalhao, setUpdateTalhao] = useState(0)
  const [codPro, setCodPro] = useState<number>(0)
  const [loadingTalhaoCultivo, setLoadingTalhaoCultivo] = useState(false)
  const [getVisibleDesenhaTalalhao, setVisibleDesenhaTalalhao] = useState(false)
  const [sizePropriedade, setSizePropriedade] = useState(0)

  const [permissions, setPermissions] = useState<ItensPerUserLogged>()

  const [dataPolygon, setDataPolygon] = useState([])
  const [dataTalhoesPolygon, setDataTalhoesPolygon] = useState([])

  const [updateSelect, setUpdateSelect] = useState<any>()

  const [nomePropriedade, setNomePropriedade] = useState<string>()

  const [propsMap, setPropsMapa] = useState<TypesMapa>({
    zoom: 2,
    center: {
      lat: 0,
      lng: 0,
    },
    style: { width: '100%', height: '88vh' },
  })

  const url = useRef(null)

  const handleClickVisuTalhao = (codPro, codTalhao) => {
    setVisibleForm(true)
    setUpdateTalhao(codTalhao)
    setCodPro(codPro)
  }

  const handleVisibleForm = () => {
    setVisibleForm(true)
    setUpdateTalhao(0)
  }

  /* Função é chamada na hora que clica no talhão */
  const handleClickPolygon = (e: google.maps.PolyMouseEvent, index) => {
    const position = e.latLng.toJSON()
    const talhao = talhoesCultivaveis.find((data, i) => i === index)

    const content = `<h5><b>Nome</b>: ${talhao.nome} <br /> <b>Área</b>: ${talhao.area}/ha <br /> `

    const dados = JSON.parse(JSON.stringify(dataPolygon))

    dados.forEach((data, i) => {
      if (i === index) {
        data.cor = 'orange'
      } else {
        data.cor = 'cyan'
      }
    })

    // <b>Lat:</b> ${position.lat.toFixed(6)} <b>Lng:</b> ${position.lng.toFixed(6)}</h5>
    if (infoWindow) {
      infoWindow.close()
    }

    infoWindow.setContent(content)
    infoWindow.setPosition(position)

    infoWindow.open({
      anchor: polygon,
      map,
      shouldFocus: true,
    })
    setDataPolygon(dados)
  }

  const handleChangeNameTalhao = (data) => {
    setInfoBoxNameTalhao(data)
  }
  const handleSelectTodosTalhoes = (data) => {
    setSelectTalhoes(data)
  }

  const handleChangeAreaTalhao = (data) => {
    setInfoBoxAreaTalhao(data)
  }

  const listarPropriedades = async () => {
    setLoadingTable(true)
    const response = await getPropriedade('')
    const dados = response.data.itens
    setDataPropriedade(dados)
    if (dados.length === 1) {
      setUpdateSelect(dados[0].cod)
      listTalhao(dados[0].cod, undefined)
    } else {
      setUpdateSelect(null)
      setCodPro(0)
    }
    setLoadingTable(false)
  }

  const listTalhao = async (data, event) => {
    if (data) {
      setUpdateSelect(data)
      setLoadingTable(true)
      const response = await getTalhaoCultivavel({ codPropriedade: data })
      setDataTalhao(response?.data.itens)
      setLoadingTable(false)
      setCodPro(data ? data : 0)
      const dataPro = dataPropriedade.find((record) => record.cod === data)
      setNomePropriedade(dataPro?.nome)
      form.setFieldsValue({ propriedade: data })
    } else {
      setDataTalhao([])
      form.setFieldsValue([])
      setUpdateSelect(data)
      setCodPro(0)
    }
  }

  const onLoadMap = (dataMap: google.maps.Map) => {
    setMap(dataMap)
  }

  const onLoadPolygon = (poly: google.maps.Polygon) => {
    setPolygon(poly)
  }

  const handleTrashTalhao = async (codPro, codTalhao) => {
    const nomePro = dataTalhao.filter((item) => item.cod === codTalhao)

    try {
      Modal.confirm({
        title: 'Excluir',
        icon: <IconAlert type='confirm' size={6} />,
        content: `Deseja realmente remover o Talhao ${nomePro[0]?.nome}?`,
        okText: 'Confirmar',
        cancelText: 'Cancelar',
        cancelButtonProps: {
          type: 'primary',
          danger: true,
        },
        onOk: async () => {
          try {
            const responseDel = await delTalhaoCultivavel(codPro, codTalhao)

            if (responseDel.status === 200) {
              Notification({
                message: 'Talhao Excluido',
                type: 'success',
              })

              listTalhao(codPro, '')
            }
          } catch (error) {
            tryError(error)
          }
        },
      })
    } catch (error) {
      if (error.response) {
        const { data } = error.response

        Notification({
          type: 'error',
          message: 'Erro',
          descricao: data.error,
        })
      }
    }
  }

  const handleSelectTableRow = (cod) => {
    setCodTalhaoSelec(cod)
    setDelListTalhao(cod)
  }

  // Função para verificar se todos os registros foram selecionados
  const isAllRowsSelected = () => {
    // Supondo que você tenha uma fonte de dados chamada dataTalhao com uma chave única chamada 'cod'
    const allRowKeys = dataTalhao.map((row) => row.cod)

    delListTalhao.length === allRowKeys.length &&
      delListTalhao.every((key) => allRowKeys.includes(key))

    // Verifique se as listas de chaves selecionadas e todas as chaves da linha são iguais
    return true
  }

  const handleRemoveAllTalhoes = async () => {
    setLoadingTable(true)
    for (let i = 0; i < delListTalhao.length; i += 1) {
      const data = delListTalhao[i]

      await delTalhaoCultivavel(codPro, data)

      if (delListTalhao.length - 1 === i) {
        listTalhao(codPro, '')
        setDelListTalhao([])
        setLoadingTable(false)
      }
    }
  }

  const handleAddObservacao = async (values) => {
    setLoadingTable(true)
    try {
      message.loading('Aguarde...')

      const allRowKeys = dataTalhao.map((row) => row.cod)

      const observacao = {
        observacao: values.observacao,
        talhoes: selectTalhoes == false ? codTalhaoSelec : allRowKeys,
        todos: selectTalhoes,
      }

      if (observacao.talhoes.length == 0) {
        message.destroy()
        Notification({
          message: 'Por favor selecione pelo menos um talhão!',
          type: 'error',
        })
      } else {
        const response = await postObservacaoTalhao(codPro, observacao)

        if (response.status === 200 && selectTalhoes == true) {
          message.destroy()
          Notification({
            message: 'Observação cadastrada para todos os talhões da safra.',
            type: 'success',
          })
        } else {
          if (observacao.talhoes.length == 1) {
            message.destroy()
            Notification({
              message: 'Observação cadastrada com sucesso',
              type: 'success',
            })
          } else {
            message.destroy()
            Notification({
              message: 'Observação cadastrada para apenas os talhões da página atual.',
              type: 'success',
            })
          }
        }
      }

      message.destroy()
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingTable(false)
    }

    form.resetFields()
    // Fechar o modal
    setOpenModalObservacao(false)
  }

  const openModalObs = () => {
    setOpenModalObservacao(true)
  }

  const handleClikBaixarKml = async (arquivo, nome, data) => {
    const response = await getKmlTalhaoCultivavel(data, arquivo)

    const blob = new Blob([response.data], {
      type: 'application/octet-stream',
    })
    url.current.href = URL.createObjectURL(blob)
    url.current.download = `${nome}.kml`
    url.current.click()
  }

  const handleClickDesenhaTalhao = () => {
    setVisibleDesenhaTalalhao(true)
  }

  const handleImportTalhao = async () => {
    setLoadingTalhaoCultivo(true)
    const response = await getTalhao(codPro, '')

    const dados = JSON.parse(JSON.stringify(response.data.itens))
    let newArray = []
    let newTalhoes = []
    dados.forEach((data, i) => {
      let newCoord = []

      data.kml.coordenadas.forEach((record) => {
        newCoord = [
          ...newCoord,
          {
            lat: parseFloat(record.latitude),
            lng: parseFloat(record.longitude),
          },
        ]

        return newCoord
      })
      newArray = [...newArray, newCoord]

      newTalhoes = [
        ...newTalhoes,
        {
          talhao: data.nome,
          coord: newArray[i],
          alert: false,
          ativo: true,
          area: data.area,
        },
      ]

      return { newArray, newTalhoes }
    })

    const centro = getBounds(newArray).getCenter()

    setPropsMapa({
      ...propsMap,
      center: {
        lat: centro.lat(),
        lng: centro.lng(),
      },
      zoom: 11,
    })

    setPolygonTalhao(newArray)
    setDataTalhoesPolygon(newTalhoes)

    setLoadingTalhaoCultivo(false)
    setModalTalhao(true)
  }

  const handleVisualizarPropri = async () => {
    message.loading('Carregando...', 99999)
    const response = await getTalhaoCultivavel({ codPropriedade: codPro })

    const dados = response.data.itens
    setTalhoesCultivaveis(dados)

    if (dados.length > 0) {
      let talhoes = []

      for (let i = 0; i < dados.length; i += 1) {
        const element = dados[i]
        let temp = []
        for (let ii = 0; ii < element.kml.coordenadas.length; ii += 1) {
          const coord = element.kml.coordenadas[ii]

          element.kml.coordenadas[ii].lng = coord.longitude
          element.kml.coordenadas[ii].lat = coord.latitude

          temp = [...temp, { lat: parseFloat(coord.lat), lng: parseFloat(coord.lng) }]
        }
        talhoes = [...talhoes, temp]
      }

      const centro = centerMap(talhoes[0])

      setPropsMapa({
        ...propsMap,
        center: {
          lat: centro.lat(),
          lng: centro.lng(),
        },
        zoom: 11,
      })

      let sumArea = 0
      for (let i = 0; i < dados.length; i += 1) {
        const sum = dados[i]
        sumArea += Number(sum.area)
      }

      setSizePropriedade(Number(sumArea.toFixed(2)))

      setDataPolygon(talhoes)
      setVisualizarPropriedade(true)
      message.destroy()
    } else {
      Notification({
        message: 'Propriedade não possui talhão',
        type: 'info',
      })
      message.destroy()
    }
  }

  useEffect(() => {
    listarPropriedades()
  }, [safraSelecionada])

  useEffect(() => {
    listarPropriedades()

    refSelect.current.focus()

    form.setFieldsValue({
      safra: JSON.parse(localStorage.getItem('codSafra')),
    })

    const idDaSafra = checkSafra('talhao/safra')

    if (!idDaSafra) {
      history.push('/home')
    }
  }, [])

  return (
    <Container>
      <ViewPage
        title='Talhões da safra'
        btnClick={null}
        disableNew={codPro === 0}
        newHide
        rotina={29}
        onPermission={setPermissions}
        btnsExta={
          <>
            <Select
              value={updateSelect}
              allowClear
              ref={refSelect}
              onChange={listTalhao}
              placeholder='Selecione uma Propriedade'
              showSearch
              popupMatchSelectWidth={false}
              optionFilterProp='children'
            >
              {dataPropriedade.map((data) => (
                <Option key={data.cod} value={data.cod}>
                  {data.nome}
                </Option>
              ))}
            </Select>
            <Button
              hidden={permissions?.inclusao === 0}
              loading={loadingTalhaoCultivo}
              icon={<Icon component={() => <Icons icon={faPlus} />} />}
              disabled={codPro === 0}
              onClick={handleVisibleForm}
              type='primary'
            >
              Novo
            </Button>
            <Button
              hidden={permissions?.inclusao === 0}
              loading={loadingTalhaoCultivo}
              icon={<Icon component={() => <FontA icon={solid('upload')} />} />}
              disabled={codPro === 0}
              onClick={handleImportTalhao}
              type='primary'
            >
              Importar
            </Button>
            <Button
              hidden={permissions?.inclusao === 0}
              disabled={codPro === 0}
              type='primary'
              icon={<Icon component={() => <FontA icon={solid('pen')} />} />}
              onClick={handleClickDesenhaTalhao}
            >
              Desenhar
            </Button>
            <Button
              onClick={handleVisualizarPropri}
              disabled={codPro === 0}
              type='primary'
              icon={<Icon component={() => <FontA icon={solid('map-location-dot')} />} />}
            >
              Visualizar propriedade
            </Button>
            <Button
              onClick={openModalObs}
              disabled={codPro === 0}
              type='primary'
              icon={<EyeOutlined />}
            >
              Adicionar Observação
            </Button>
            <Popconfirm
              onConfirm={handleRemoveAllTalhoes}
              title='Deseja realmente os talhões selecionados?'
              icon={<IconAlert type='confirm' size={4} />}
            >
              <Button
                hidden={permissions?.exclusao === 0}
                disabled={delListTalhao.length <= 1}
                type='primary'
                icon={<Icon component={() => <FontA icon={solid('trash')} />} />}
                danger
              >
                Remover selecionados
              </Button>
            </Popconfirm>
            <Button
              hidden={process.env.NODE_ENV === 'production'}
              onClick={() => setOpenMapLine(true)}
              disabled={codPro === 0}
              type='primary'
              icon={<Icon component={() => <FontA icon={solid('map-location-dot')} />} />}
            >
              Linhas de pulverização
            </Button>
          </>
        }
        content={
          <FormTalhaoSafra
            onClose={setVisibleForm}
            dataTalhao={dataTalhao}
            permissions={permissions}
            visible={visibleForm}
            update={udateTalhao}
            setUpdate={setUpdateTalhao}
            codPro={codPro}
            atualizar={listTalhao}
          />
        }
      >
        <Table
          rowKey='cod'
          loading={loadingTable}
          rowSelection={
            permissions?.exclusao === 1
              ? {
                  type: 'checkbox',
                  selectedRowKeys: delListTalhao,
                  onChange: (data) => handleSelectTableRow(data),
                }
              : null
          }
          scroll={{ y: 'calc(90vh - 275px)', x: 'auto' }}
          pagination={pagination}
          footer={() => (
            <div
              style={{
                display: 'flex',
                width: '100%',
                justifyContent: 'right',
              }}
            >
              <b>Total geral: {dataTalhao.length}</b>
            </div>
          )}
          dataSource={dataTalhao}
          bordered
          // @ts-ignore
          atualizar={listTalhao}
          size='small'
          columns={[
            {
              key: 1,
              title: 'Talhão',
              dataIndex: 'kml',
              width: '80px',
              render: (data) => {
                return (
                  <>
                    <Icon
                      component={() => <Svg coordinates={data?.coordenadas} fill='#70ce9f' />}
                    />
                  </>
                )
              },
            },
            {
              key: 1,
              title: 'Nome',
              dataIndex: 'nome',
              render: (nome) => <div style={{ minWidth: 50 }}>{nome}</div>,
            },
            {
              key: 2,
              title: 'Área (ha)',
              dataIndex: 'area',
              render: (data) => {
                return <div style={{ minWidth: 60 }}>{data.replace('.', ',')}</div>
              },
            },
            {
              title: 'Ações',
              dataIndex: 'cod',
              key: 'acao',
              align: 'center',
              width: '135px',
              render: (data, fulldata) => (
                <>
                  <Space>
                    <Button
                      shape='circle'
                      hidden={permissions?.alteracao === 0 && permissions?.acesso === 0}
                      onClick={() => handleClickVisuTalhao(fulldata.cod_propriedade, data)}
                      icon={
                        <FontA icon={permissions?.acesso === 1 ? solid('eye') : solid('pen')} />
                      }
                      size='middle'
                    />
                    <Button
                      shape='circle'
                      disabled={fulldata.kml == null}
                      onClick={() => handleClikBaixarKml(fulldata.arquivo, fulldata.nome, data)}
                      icon={<FontA icon={solid('download')} />}
                      size='middle'
                    />
                    <Button
                      hidden={permissions?.exclusao === 0}
                      shape='circle'
                      onClick={() => handleTrashTalhao(fulldata.cod_propriedade, data)}
                      className='trash-button'
                      type='primary'
                      icon={<FontA icon={solid('trash')} />}
                      size='middle'
                    />
                  </Space>
                  <a style={{ display: 'none' }} href='empty' ref={url}>
                    ref
                  </a>
                </>
              ),
            },
          ]}
          onRow={(record) => {
            return {
              onDoubleClick: () => {
                handleClickVisuTalhao(record.cod_propriedade, record.cod)
              },
            }
          }}
        />
      </ViewPage>

      <Modal
        closeIcon
        style={{ top: 20, minWidth: '95%' }}
        open={openMapLine}
        okButtonProps={{ hidden: true }}
        cancelButtonProps={{ hidden: true }}
      >
        <LinhaPlanejada talhao={talhaoSelecionado} onClose={setOpenMapLine} />
      </Modal>

      <Modal
        style={{ top: 20, minWidth: '95%' }}
        onCancel={() => setVisibleDesenhaTalalhao(false)}
        open={getVisibleDesenhaTalalhao}
        okButtonProps={{ hidden: true }}
        cancelButtonProps={{ danger: true, type: 'primary' }}
      >
        <DesenhaTalhao
          update={udateTalhao}
          propriedade={codPro}
          atualizar={listTalhao}
          cultivavel
        />
      </Modal>

      <Modal
        open={visualizarPropriedade}
        onCancel={() => setVisualizarPropriedade(false)}
        style={{ top: '10px', minWidth: '97%' }}
        closable={false}
        footer={false}
      >
        <ContainerMap>
          {/* @ts-ignore */}
          <GoogleMap
            mapContainerClassName='floating'
            onLoad={onLoadMap}
            zoom={propsMap.zoom}
            mapContainerStyle={{
              width: propsMap.style.width,
              height: '93vh',
            }}
            center={propsMap.center}
            options={{
              streetViewControl: false,
              fullscreenControl: false,
              mapTypeControl: false,
              mapTypeId: 'hybrid',
            }}
          >
            {dataPolygon.map((data, i) => {
              const talhao = talhoesCultivaveis.find((record, ii) => ii === i)

              const center = centerMap(data)

              return (
                <>
                  <Polygon
                    paths={data}
                    onClick={(e) => handleClickPolygon(e, i)}
                    onLoad={onLoadPolygon}
                    options={{
                      fillColor: data.cor ? data.cor : 'cyan',
                      strokeColor: data.cor ? data.cor : 'cyan',
                    }}
                  />
                  {/* @ts-ignore */}
                  <InfoBox
                    options={{
                      closeBoxURL: '',
                      enableEventPropagation: true,
                    }}
                    position={center}
                  >
                    <div
                      style={{
                        overflow: 'hidden',
                        width: '400px',
                        textShadow: '2px 2px 3px black',
                      }}
                    >
                      <h4>
                        <b
                          hidden={infoBoxNameTalhao}
                          style={{ overflow: 'hidden', color: 'white' }}
                        >
                          {talhao.nome}
                        </b>
                        <br />
                        <b
                          hidden={infoBoxAreaTalhao}
                          style={{ overflow: 'hidden', color: 'white' }}
                        >
                          {` Área ${talhao.area}`}
                        </b>
                      </h4>
                    </div>
                  </InfoBox>
                </>
              )
            })}
            <Card
              title={
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  {nomePropriedade}
                  <small>
                    <b>Área da propriedade: {sizePropriedade}</b>
                  </small>
                </div>
              }
              className='floating-safra'
              size='small'
            >
              <Form form={form} layout='vertical'>
                <Form.Item label='Nome dos talhões'>
                  <Switch
                    onChange={(data) => handleChangeNameTalhao(!data)}
                    unCheckedChildren='Não'
                    checkedChildren='Sim'
                  />
                </Form.Item>
                <Form.Item label='Área dos talhões'>
                  <Switch
                    onChange={(data) => handleChangeAreaTalhao(!data)}
                    unCheckedChildren='Não'
                    checkedChildren='Sim'
                  />
                </Form.Item>
                <Form.Item>
                  <Button
                    type='primary'
                    danger
                    block
                    onClick={() => setVisualizarPropriedade(false)}
                  >
                    Fechar
                  </Button>
                </Form.Item>
              </Form>
            </Card>
          </GoogleMap>
        </ContainerMap>
      </Modal>

      <Modal
        open={openModalObservacao}
        onCancel={() => setOpenModalObservacao(false)}
        footer={[
          <Button type='primary' danger onClick={() => setOpenModalObservacao(false)}>
            Fechar
          </Button>,
          <Button type='primary' onClick={() => form.submit()}>
            Salvar
          </Button>,
        ]}
      >
        <Card className='floating-safra' size='small'>
          <Form form={form} layout='vertical' onFinish={handleAddObservacao}>
            <Form.Item
              rules={[
                {
                  required: true,
                },
              ]}
              label='Observação'
              name='observacao'
            >
              <Input onChange={({ target }) => setObservacao(target.value)} value={observacao} />
            </Form.Item>
            <Form.Item label='Deseja aplicar para todos talhões da safra?'>
              <Switch
                onChange={(data) => handleSelectTodosTalhoes(data)}
                unCheckedChildren='Não'
                checkedChildren='Sim'
              />
            </Form.Item>
          </Form>
        </Card>
      </Modal>

      <Form>
        <Form.Item hidden name='propriedade'>
          <Input accept='.kml' hidden type='file' />
        </Form.Item>
      </Form>

      <Modal
        closeIcon
        style={{ top: 20, minWidth: '95%' }}
        open={modalTalhao}
        okButtonProps={{ hidden: true }}
        cancelButtonProps={{ hidden: true }}
      >
        <ImporteKmlTalhao
          safra
          listTalhoesRecord={dataTalhao}
          mapSet={propsMap}
          propriedade={codPro}
          nameTalhao='Safra'
          paths={polygonTalhao}
          dataPolygon={dataTalhoesPolygon}
          onClose={() => {
            setModalTalhao(false)
            listTalhao(codPro, '')
          }}
        />
      </Modal>
    </Container>
  )
}

export default TalhaoSafra